module.exports = __webpack_public_path__ + "img/piero.26701ceb.jpg";